import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { destroy, put } from '../modules/recurring_order'

import component from 'components/RecurringOrders/Edit'

const mapActionCreators = {
  onSubmit: put,
  handleDelete: destroy // NOTE: this cannot be named destroy as reduxForm uses that..
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state) => ({
  recurring_order: state.recurring_order
})

const form = reduxForm({
  form: 'edit-recurring_order',
  fields: ['id', 'name'], // NOTE: id can't be updated, just used to send to API
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name.'

    return errors
  }
}, state => ({
  initialValues: state.recurring_order
}))(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/RecurringOrders/containers/EditRecurringOrderContainer.js